export let API_URL, STOMP_URL;

export * from './notifications';
export * from './forms';
export * from './languages';

if (process.env.REACT_APP_ENV === 'production') {
    STOMP_URL = 'wss://notify.inplayer.com:15671/ws';
    API_URL = 'https://services.inplayer.com';
} else {
    STOMP_URL = 'wss://staging-v2.inplayer.com:15671/ws';
    API_URL = 'https://staging-v2.inplayer.com';
}



// WEBPACK FOOTER //
// ./src/constants/index.js